const actions = {
  GET_S3_UPLOAD_URL: 'GET_S3_UPLOAD_URL',
  GET_S3_UPLOAD_URL_SUCCESS: 'GET_S3_UPLOAD_URL_SUCCESS',
  GET_S3_UPLOAD_URL_ERROR: 'GET_S3_UPLOAD_URL_ERROR',

  SAVE_FILE_METADATA: 'SAVE_FILE_METADATA',
  SAVING_FILE_METADATA: 'SAVING_FILE_METADATA',
  SAVE_FILE_METADATA_SUCCESS: 'SAVE_FILE_METADATA_SUCCESS',
  SAVE_FILE_METADATA_FAILED: 'SAVE_FILE_METADATA_FAILED',

  FETCH_FILES: 'FETCH_FILES',
  FETCHING_FILES: 'FETCHING_FILES',
  FETCH_FILES_SUCCESS: 'FETCH_FILES_SUCCESS',
  FETCH_FILES_FAILED: 'FETCH_FILES_FAILED',

  FETCH_FILE_ACCESS_URL: 'FETCH_FILE_ACCESS_URL',
  FETCHING_FILE_ACCESS_URL: 'FETCHING_FILE_ACCESS_URL',
  FETCH_FILE_ACCESS_URL_SUCCESS: 'FETCH_FILE_ACCESS_URL_SUCCESS',
  FETCH_FILE_ACCESS_URL_FAILED: 'FETCH_FILE_ACCESS_URL_FAILED',

  getS3UploadUrl: payload => ({
    type: actions.GET_S3_UPLOAD_URL,
    payload
  }),

  saveFileMetadata: payload => ({
    type: actions.SAVE_FILE_METADATA,
    payload
  }),

  fetchFiles: payload => ({
    type: actions.FETCH_FILES,
    payload
  }),

  fetchFileAccessURL: (id, payload) => ({
    type: actions.FETCH_FILE_ACCESS_URL,
    id,
    payload
  })
};
export default actions;
